'use strict';
import { gsap } from 'gsap';
import { initGuidelineKv } from '../utility/_modules';
// import { initSpanWrap } from '../utility/_spanWrap';
window.addEventListener('load', () => {
  initGuidelineKv();
});
